var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("SelectDeviceModalGroup", {
    attrs: { filterByChannelId: _vm.filterByChannelId },
    on: { cancel: _vm.handleCancel, submit: _vm.handleSelectAddressSubmit },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }